export default __webpack_public_path__ + "static/media/Photographs1.fcc66fe3.png";